import React                from 'react';
import PropTypes            from 'prop-types';
import VXButtonOutline      from "../../SimpleElements/VXButton/Presets/VXButtonOutline";
import {VXButtonLineConfig} from "../../SimpleElements/VXButton/VXButtonConfig";

class ButtonRow extends React.Component {
	render() {
		return (
			<div className="row cta-row">
				<VXButtonOutline line1={[new VXButtonLineConfig(this.props.cta)]} link={this.props.link} callback={this.props.callback} />
			</div>
		);
	}
}

ButtonRow.propTypes = {
	cta:     PropTypes.string.isRequired,
	link:    PropTypes.string.isRequired,
	callback:   PropTypes.func,
};

export default ButtonRow;